import { render, staticRenderFns } from "./DeleteCoupon.vue?vue&type=template&id=8c67cbbe&scoped=true"
import script from "./DeleteCoupon.vue?vue&type=script&lang=js"
export * from "./DeleteCoupon.vue?vue&type=script&lang=js"
import style0 from "./DeleteCoupon.vue?vue&type=style&index=0&id=8c67cbbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c67cbbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c67cbbe')) {
      api.createRecord('8c67cbbe', component.options)
    } else {
      api.reload('8c67cbbe', component.options)
    }
    module.hot.accept("./DeleteCoupon.vue?vue&type=template&id=8c67cbbe&scoped=true", function () {
      api.rerender('8c67cbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/DeleteCoupon.vue"
export default component.exports